import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    template: `
        <div fxLayout="column">
            <mat-toolbar>
                <h3>Edit User</h3>
                <span fxFlex></span>
            </mat-toolbar>
            <mat-tab-group>
                <mat-tab label="Profile">
                    <user-edit-profile [userId]="userId"></user-edit-profile>
                </mat-tab>
                <mat-tab label="My Briefing">
                    <ng-template matTabContent>
                        <user-edit-digest [userId]="userId"></user-edit-digest>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Topics">
                    <ng-template matTabContent>
                        <user-edit-topics [userId]="userId"></user-edit-topics>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Briefings">
                    <ng-template matTabContent>
                        <user-edit-briefings [userId]="userId"></user-edit-briefings>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Groups">
                    <ng-template matTabContent>
                        <user-edit-groups [userId]="userId"></user-edit-groups>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    `
})
export class UserEditComponent implements OnInit, OnDestroy {
    private cleanupTime = new Subject<void>();
    userId: any;

    constructor(private route: ActivatedRoute){}

    ngOnInit(): void {
        this.route.params.subscribe(params => this.userId = params.userId);
    }

    ngOnDestroy() {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}